(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (window.NomavikCartDrawer) return;
    window.NomavikCartDrawer = true;

    const getDrawer = () => document.querySelector('[data-cart-drawer]');
    const getDrawerRoot = () => getDrawer()?.closest('[id^="shopify-section-"]');
    const getSectionId = (element) => element?.id?.replace('shopify-section-', '') || '';

    const setPageLock = (locked) => {
      document.documentElement.classList.toggle('cart-drawer-open', locked);
      document.body.classList.toggle('cart-drawer-open', locked);
    };

    const openDrawer = () => {
      const drawer = getDrawer();
      if (!drawer) return;
      if (!drawer.open) drawer.showModal();
      setPageLock(true);
      window.requestAnimationFrame(() => drawer.querySelector('[data-cart-drawer-close]')?.focus());
    };

    const closeDrawer = () => {
      const drawer = getDrawer();
      if (drawer?.open) drawer.close();
      setPageLock(false);
    };

    const showError = () => {
      const drawer = getDrawer();
      const status = drawer?.querySelector('[data-cart-drawer-status]');
      if (status) {
        status.textContent = drawer.dataset.errorMessage || '';
        status.hidden = false;
      }
      openDrawer();
    };

    const replaceSection = (id, html) => {
      if (!id || !html) return;
      const current = document.getElementById(`shopify-section-${id}`);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.getElementById(`shopify-section-${id}`);
      if (current && next) current.replaceWith(next);
    };

    const refreshSections = async (openAfter = false) => {
      const drawerRoot = getDrawerRoot();
      const headerRoot = document.querySelector('.section-header-wrapper[id^="shopify-section-"]');
      const drawerId = getSectionId(drawerRoot);
      const headerId = getSectionId(headerRoot);
      const ids = [drawerId, headerId].filter(Boolean);
      const url = new URL(window.location.href);
      url.searchParams.set('sections', ids.join(','));
      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Cart sections could not be refreshed');
      const sections = await response.json();
      ids.forEach((id) => replaceSection(id, sections[id]));
      if (openAfter) openDrawer();
    };

    const addProduct = async (form, submitter) => {
      const drawer = getDrawer();
      if (!drawer) return;
      const formData = new FormData(form);
      formData.delete('return_to');
      if (submitter) submitter.disabled = true;
      try {
        const response = await fetch(`${drawer.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        if (!response.ok) throw new Error('Product could not be added');
        await refreshSections(true);
      } catch (error) {
        showError();
      } finally {
        if (submitter?.isConnected) submitter.disabled = false;
      }
    };

    const changeLine = async (button) => {
      const drawer = getDrawer();
      if (!drawer) return;
      button.disabled = true;
      try {
        const response = await fetch(`${drawer.dataset.cartChangeUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(button.dataset.line), quantity: Number(button.dataset.quantity) }),
        });
        if (!response.ok) throw new Error('Cart line could not be updated');
        await refreshSections(true);
      } catch (error) {
        button.disabled = false;
        showError();
      }
    };

    document.addEventListener('click', async (event) => {
      const close = event.target.closest('[data-cart-drawer-close]');
      if (close) {
        closeDrawer();
        return;
      }

      const drawer = getDrawer();
      if (event.target === drawer) {
        closeDrawer();
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      if (change) {
        await changeLine(change);
        return;
      }

      const cartLink = event.target.closest('.header__cart');
      if (!cartLink || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      try {
        await refreshSections(true);
      } catch (error) {
        openDrawer();
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const drawer = getDrawer();
      if (!drawer) return;
      const action = new URL(form.action, window.location.origin).pathname;
      if (action !== drawer.dataset.cartAddUrl) return;
      event.preventDefault();
      addProduct(form, event.submitter);
    });

    document.addEventListener('close', (event) => {
      if (event.target.matches?.('[data-cart-drawer]')) setPageLock(false);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
  class NomavikFilters extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-filters-panel]');
      this.sort = this.querySelector('[data-filters-sort]');
      this.opener = this.querySelector('[data-filters-open]');
      this.overlay = this.querySelector('[data-filters-overlay]');
      this.form = this.querySelector('[data-filters-form]');
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.timer = null;

      this.onSort = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      };
      if (this.sort) this.sort.addEventListener('change', this.onSort);

      if (!this.panel) return;

      this.onChange = () => {
        if (!this.desktop.matches) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.form.requestSubmit(), 350);
      };
      this.onFormData = (event) => {
        // Do not send empty fields (for example an empty price range).
        for (const [key, value] of Array.from(event.formData.entries())) {
          if (value === '') event.formData.delete(key);
        }
      };
      this.onKeydown = (event) => {
        if (!this.isOpen) return;
        if (event.key === 'Escape') {
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        const items = Array.from(
          this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary')
        ).filter((el) => el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };
      this.onMedia = () => {
        if (this.desktop.matches && this.isOpen) this.close(false);
        this.syncInert();
      };

      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('formdata', this.onFormData);
      document.addEventListener('keydown', this.onKeydown);
      this.desktop.addEventListener('change', this.onMedia);
      if (this.opener) this.opener.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-filters-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      this.isOpen = false;
      this.syncInert();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      if (this.desktop) this.desktop.removeEventListener('change', this.onMedia);
      clearTimeout(this.timer);
      document.documentElement.style.overflow = '';
    }

    syncInert() {
      // Below 990px the closed drawer must not be reachable by keyboard or screen readers.
      this.panel.inert = !this.desktop.matches && !this.isOpen;
    }

    open() {
      this.isOpen = true;
      this.panel.inert = false;
      this.panel.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-modal', 'true');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      const close = this.panel.querySelector('[data-filters-close]');
      if (close) close.focus();
    }

    close(restoreFocus = true) {
      this.isOpen = false;
      this.panel.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      this.panel.removeAttribute('role');
      this.panel.removeAttribute('aria-modal');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      this.syncInert();
      if (restoreFocus && this.opener) this.opener.focus();
    }
  }

  if (!customElements.get('nomavik-filters')) {
    customElements.define('nomavik-filters', NomavikFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('.collections-section--m-scroll').forEach((section) => {
        if (section.dataset.carouselReady) return;
        const grid = section.querySelector('.collections-section__grid');
        const cards = Array.from(section.querySelectorAll('.collection-tile'));
        const dots = Array.from(section.querySelectorAll('[data-collection-dot]'));
        if (!grid || cards.length < 2 || !dots.length) return;
        section.dataset.carouselReady = 'true';
        const mobile = window.matchMedia('(max-width: 749px)');
        const status = section.querySelector('[data-collection-status]');
        let active = 0;
        let start = null;
        let suppressClickUntil = 0;
        const show = (index, announce = true) => {
          active = (index + cards.length) % cards.length;
          cards.forEach((card, i) => { card.hidden = mobile.matches && i !== active; });
          dots.forEach((dot, i) => {
            if (i === active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (announce && mobile.matches) status.textContent = cards[active].querySelector('.collection-tile__title').textContent.trim();
          section.classList.toggle('collections-section--carousel-ready', mobile.matches);
        };
        dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
        grid.addEventListener('dragstart', (event) => {
          if (mobile.matches) event.preventDefault();
        });
        grid.addEventListener('pointerdown', (event) => {
          start = mobile.matches && event.isPrimary && event.button === 0
            ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
        });
        grid.addEventListener('pointercancel', () => { start = null; });
        grid.addEventListener('pointerup', (event) => {
          if (!start || event.pointerId !== start.id) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          start = null;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
          suppressClickUntil = performance.now() + 400;
          show(active + (dx < 0 ? 1 : -1));
        });
        grid.addEventListener('click', (event) => {
          if (performance.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);
        mobile.addEventListener('change', () => { start = null; show(active, false); });
        show(0, false);
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  // Move the focus to the confirmation or error message after the page reloads.
  document.addEventListener('DOMContentLoaded', () => {
    const feedback = document.querySelector('[data-contact-feedback]');
    if (feedback) feedback.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('.fp--swipe').forEach((section) => {
        if (section.dataset.swipeReady) return;
        const grid = section.querySelector('.fp__list');
        const cards = Array.from(section.querySelectorAll('.fp__list > li'));
        const dots = Array.from(section.querySelectorAll('[data-product-dot]'));
        if (!grid || cards.length < 2 || !dots.length) return;
        section.dataset.swipeReady = 'true';
        const mobile = window.matchMedia('(max-width: 749px)');
        const status = section.querySelector('[data-product-status]');
        let active = 0;
        let start = null;
        let suppressClickUntil = 0;
        const show = (index, announce = true) => {
          active = (index + cards.length) % cards.length;
          cards.forEach((card, i) => { card.hidden = mobile.matches && i !== active; });
          dots.forEach((dot, i) => {
            if (i === active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (announce && mobile.matches) status.textContent = cards[active].querySelector('.product-card__title').textContent.trim();
          section.classList.toggle('fp--swipe-ready', mobile.matches);
        };
        dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
        grid.addEventListener('dragstart', (event) => {
          if (mobile.matches) event.preventDefault();
        });
        grid.addEventListener('pointerdown', (event) => {
          start = mobile.matches && event.isPrimary && event.button === 0
            ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
        });
        grid.addEventListener('pointercancel', () => { start = null; });
        grid.addEventListener('pointerup', (event) => {
          if (!start || event.pointerId !== start.id) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          start = null;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
          suppressClickUntil = performance.now() + 400;
          show(active + (dx < 0 ? 1 : -1));
        });
        grid.addEventListener('click', (event) => {
          if (performance.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);
        mobile.addEventListener('change', () => { start = null; show(active, false); });
        show(0, false);
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  if (!customElements.get('nomavik-carousel')) {
    customElements.define(
      'nomavik-carousel',
      class NomavikCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          this.prev = this.querySelector('[data-carousel-prev]');
          this.next = this.querySelector('[data-carousel-next]');
          if (!this.track) return;

          this.onScroll = () => this.update();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.track);

          if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
          if (this.next) this.next.addEventListener('click', () => this.move(1));
          this.update();
        }

        disconnectedCallback() {
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
          if (this.observer) this.observer.disconnect();
        }

        move(direction) {
          const first = this.track.firstElementChild;
          if (!first) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = first.getBoundingClientRect().width + gap;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * step, behavior: reduce ? 'auto' : 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const arrows = this.querySelector('.fp__arrows');
          if (arrows) arrows.hidden = max <= 1;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const closeAll = (except) => {
      document.querySelectorAll('[data-header-details][open]').forEach((el) => {
        if (el !== except) el.removeAttribute('open');
      });
    };

    document.addEventListener('toggle', (event) => {
      if (event.target.matches && event.target.matches('[data-header-details]') && event.target.open) {
        closeAll(event.target);
        const input = event.target.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('[data-header-details][open]');
      if (!open) return;
      open.removeAttribute('open');
      const summary = open.querySelector('summary');
      if (summary) summary.focus();
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-header-details]')) closeAll();
    });

    // While the mobile menu is open, Tab loops between the menu button and the menu links
    // instead of reaching the page content hidden behind the panel.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const drawer = document.querySelector('[data-header-drawer][open]');
      if (!drawer || !drawer.offsetParent) return;
      const items = [drawer.querySelector('summary'), ...drawer.querySelectorAll('.header__drawer-panel a[href]')];
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (!drawer.contains(active)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-grid"]) return;
  try {
    
  // Product page with a vertical grid of photos.
  // The photos shown are ALWAYS those written by the server (Liquid) for the selected variant.
  // Choosing another colour opens the same page for that variant (?variant=ID), keeping the template (?view=)
  // and the preview parameters of the address: the server then writes the gallery of that variant.
  class NomavikProductGrid extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-index]')) this.onOptionChange();
      });
      // Quantity buttons: one listener for the whole block
      this.addEventListener('click', (event) => {
        const minus = event.target.closest('[data-qty-minus]');
        const plus = event.target.closest('[data-qty-plus]');
        if (minus) this.stepQuantity(-1);
        if (plus) this.stepQuantity(1);
      });

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-qty-input]')) this.clampQuantity();
      });

      this.prepareInfo();
      this.classList.add('is-ready');
      this.restorePosition();
      this.clampQuantity();
      this.setupGallery();
      this.updateSticky();
      this.onResize = () => this.updateSticky();
      window.addEventListener('resize', this.onResize);
      if ('ResizeObserver' in window) {
        const info = this.querySelector('[data-info]');
        if (info) {
          this.resizeObserver = new ResizeObserver(() => this.updateSticky());
          this.resizeObserver.observe(info);
        }
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.galleryObserver) this.galleryObserver.disconnect();
      window.removeEventListener('resize', this.onResize);
    }

    // ---- Mobile gallery
    setupGallery() {
      this.galleryViewport = this.querySelector('[data-gallery-viewport]');
      this.gallerySlides = Array.from(this.querySelectorAll('.pg__photo[data-media-id]'));
      this.galleryThumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.galleryThumbList = this.querySelector('[data-gallery-thumbs]');
      this.galleryStatus = this.querySelector('[data-gallery-status]');
      if (!this.galleryViewport || !this.gallerySlides.length) return;

      if (this.galleryThumbList) this.galleryThumbList.hidden = this.gallerySlides.length < 2;
      this.galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showGalleryMedia(thumb.dataset.galleryThumb, true, true));
      });

      if ('IntersectionObserver' in window) {
        this.galleryObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.markGalleryActive(entry.target.dataset.mediaId, false);
              }
            });
          },
          { root: this.galleryViewport, threshold: [0.6] }
        );
        this.gallerySlides.forEach((slide) => this.galleryObserver.observe(slide));
      }

      this.markGalleryActive(this.gallerySlides[0].dataset.mediaId, false);
    }

    gallerySlideLeft(slide) {
      return slide.getBoundingClientRect().left - this.galleryViewport.getBoundingClientRect().left + this.galleryViewport.scrollLeft;
    }

    showGalleryMedia(mediaId, smooth, announce) {
      const slide = this.gallerySlides.find((item) => item.dataset.mediaId === String(mediaId));
      if (!slide || !this.galleryViewport) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (smooth && !reduce) this.galleryViewport.scrollTo({ left: this.gallerySlideLeft(slide), behavior: 'smooth' });
      else this.galleryViewport.scrollLeft = this.gallerySlideLeft(slide);
      this.markGalleryActive(mediaId, announce);
    }

    markGalleryActive(mediaId, announce) {
      const activeId = String(mediaId || '');
      this.galleryThumbs.forEach((thumb) => {
        thumb.setAttribute('aria-current', String(thumb.dataset.galleryThumb === activeId));
      });
      const activeThumb = this.galleryThumbs.find((thumb) => thumb.dataset.galleryThumb === activeId);
      if (activeThumb && this.galleryThumbList && !this.galleryThumbList.hidden) {
        const listBox = this.galleryThumbList.getBoundingClientRect();
        const thumbBox = activeThumb.getBoundingClientRect();
        if (thumbBox.left < listBox.left) this.galleryThumbList.scrollLeft += thumbBox.left - listBox.left - 8;
        else if (thumbBox.right > listBox.right) this.galleryThumbList.scrollLeft += thumbBox.right - listBox.right + 8;
      }
      if (announce && this.galleryStatus) {
        const index = this.gallerySlides.findIndex((slide) => slide.dataset.mediaId === activeId);
        if (index > -1) {
          this.galleryStatus.textContent = (this.dataset.positionLabel || '')
            .replace('__CURRENT__', String(index + 1))
            .replace('__TOTAL__', String(this.gallerySlides.length));
        }
      }
    }

    // ---- Addresses
    // Same page as the one shown (same path, same preview/template parameters), for another variant
    addressFor(variantId) {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('variant', variantId);
      if (this.dataset.templateSuffix) url.searchParams.set('view', this.dataset.templateSuffix);
      return url.pathname + url.search;
    }

    // ---- Information panel
    prepareInfo() {
      this.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach((button) => {
        button.hidden = false;
      });
    }

    stepQuantity(delta) {
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;
      const min = parseInt(input.min || '1', 10);
      input.value = String(Math.max(min, (parseInt(input.value, 10) || min) + delta));
      this.clampQuantity();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Quantity between 1 and the stock still available (the "max" is only written when Shopify tracks the stock and refuses sales without stock)
    clampQuantity() {
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;
      const min = parseInt(input.min || '1', 10);
      const max = parseInt(input.max, 10);
      let value = parseInt(input.value, 10);
      if (!Number.isFinite(value)) value = min;
      value = Math.max(min, value);
      if (Number.isFinite(max)) value = Math.min(max, value);
      input.value = String(value);
      const atMax = Number.isFinite(max) && value >= max;
      const plus = this.querySelector('[data-qty-plus]');
      if (plus) plus.disabled = atMax;
      const note = this.querySelector('[data-qty-note]');
      if (note && !note.hasAttribute('data-qty-note-fixed')) note.hidden = !atMax;
    }

    // Sticky panel: a panel taller than the screen is pinned by its END, so that all of it can be reached
    updateSticky() {
      const info = this.querySelector('[data-info]');
      if (!info || !this.closest('.pg--sticky')) return;
      if (!window.matchMedia('(min-width: 990px)').matches) {
        info.style.removeProperty('top');
        return;
      }
      let offset = 24;
      const header = document.querySelector('.header--sticky');
      if (header) offset += header.getBoundingClientRect().height;
      info.style.top = `${Math.min(offset, window.innerHeight - info.offsetHeight - 24)}px`;
    }

    // ---- Variants
    variants() {
      const data = this.querySelector('[data-variants]');
      return data ? JSON.parse(data.textContent) : [];
    }

    selectedOptions() {
      const values = [];
      this.querySelectorAll('[data-option-index]').forEach((control) => {
        const index = parseInt(control.dataset.optionIndex, 10);
        if (control.tagName === 'SELECT') values[index] = control.value;
        else if (control.checked) values[index] = control.value;
      });
      return values;
    }

    onOptionChange() {
      const selected = this.selectedOptions();
      this.querySelectorAll('[data-selected-value]').forEach((label, index) => {
        if (selected[index]) label.textContent = selected[index];
      });
      const variant = this.variants().find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        const button = this.querySelector('.pg__add');
        if (button) {
          button.disabled = true;
          button.textContent = this.dataset.unavailable;
        }
        return;
      }
      if (String(variant.id) === this.dataset.variant) return;
      this.goTo(variant);
    }

    // Opens the page of the variant. The scroll position and the focused choice are kept for the next page.
    goTo(variant) {
      try {
        const focused = document.activeElement;
        const quantity = this.querySelector('[data-qty-input]');
        sessionStorage.setItem(
          'pgNavigation',
          JSON.stringify({
            path: window.location.pathname,
            y: window.scrollY,
            qty: quantity ? quantity.value : null,
            focus: focused && focused.matches && focused.matches('[data-option-index]') ? { index: focused.dataset.optionIndex, value: focused.value } : null,
          })
        );
      } catch (error) {
        /* storage not available: the page simply opens at the top */
      }
      window.location.replace(this.addressFor(variant.id));
    }

    restorePosition() {
      try {
        const saved = JSON.parse(sessionStorage.getItem('pgNavigation') || 'null');
        sessionStorage.removeItem('pgNavigation');
        if (!saved || saved.path !== window.location.pathname) return;
        const quantity = this.querySelector('[data-qty-input]');
        if (quantity && saved.qty) quantity.value = saved.qty;
        window.requestAnimationFrame(() => {
          window.scrollTo(0, saved.y);
          if (saved.focus) {
            const target = Array.from(this.querySelectorAll('input[data-option-index], select[data-option-index]')).find(
              (control) => control.dataset.optionIndex === saved.focus.index && control.value === saved.focus.value
            );
            if (target) target.focus({ preventScroll: true });
          }
        });
      } catch (error) {
        /* nothing to restore */
      }
    }
  }

  if (!customElements.get('nomavik-product-grid')) {
    customElements.define('nomavik-product-grid', NomavikProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class NomavikProduct extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.thumbs = this.querySelectorAll('[data-thumb]');
      this.counter = this.querySelector('[data-current]');
      this.counterTotal = this.querySelector('[data-total]');
      this.counterBox = this.querySelector('.mp__counter');
      this.thumbList = this.querySelector('[data-thumbs]');
      this.emptyBox = this.querySelector('[data-gallery-empty]');
      this.prevButton = this.querySelector('[data-gallery-prev]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.status = this.querySelector('[data-gallery-status]');
      this.activeId = null;
      this.allSlides = Array.from(this.querySelectorAll('[data-media-id]'));
      // The ONE list of photos available for the variant shown: slides, thumbnails, counter, arrows,
      // clicks and swipes all use it (never the position among all the photos of the product)
      this.group = this.allSlides.filter((slide) => !slide.hidden);
      this.variantsData = this.querySelector('[data-variants]');
      this.variants = this.variantsData ? JSON.parse(this.variantsData.textContent) : [];
      this.controller = null;
      // 'variant' = the gallery follows the selected variant (photos carry a marker); 'classic' = every photo is shown
      this.galleryByVariant = this.dataset.galleryMode === 'variant';
      this.currentMedia = null;

      this.thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => {
          if (!this.group.some((slide) => slide.dataset.mediaId === thumb.dataset.thumb)) return;
          this.showMedia(thumb.dataset.thumb, true);
          this.announce();
        })
      );
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));
      this.setupGallery();
      this.setupQuantity();

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-index]')) this.onOptionChange();
      });
      this.preloadedMedia = new Set();
      this.addEventListener('pointerover', (event) => this.preloadOptionMedia(event));
      this.addEventListener('pointerdown', (event) => this.preloadOptionMedia(event));
      this.addEventListener('focusin', (event) => this.preloadOptionMedia(event));

      this.classList.add('is-ready');
      if (this.galleryByVariant) {
        const start = this.variants.find((item) => String(item.id) === this.dataset.variant);
        if (start) this.currentMedia = start.media;
        // The list sent by the server for the variant shown is the reference (the counter was computed from it)
        const served = this.servedGroup(this.viewport && this.viewport.dataset.groupIds);
        if (served) {
          if (start) {
            const mine = this.visibleSlides(start);
            if (mine.length !== served.length || mine.some((slide, index) => slide !== served[index])) {
              console.warn('NOMAVIK gallery: the photos computed in the browser differ from the server list; the server list is used.');
            }
          }
          this.applyGroup(served, true);
        } else if (start) {
          this.applyGallery(start, true);
        }
      }
      const initial = this.viewport && this.viewport.dataset.initial;
      if (initial) this.showMedia(initial, false);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
      cancelAnimationFrame(this.snapFrame);
    }

    // ---- Gallery
    // Photos available for the variant shown (the others are hidden)
    slides() {
      return this.group;
    }

    setupGallery() {
      if (!this.viewport || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && this.group.includes(entry.target)) this.markActive(entry.target.dataset.mediaId);
          });
        },
        { root: this.viewport, threshold: [0.6] }
      );
      this.observeSlides();
      this.markActive(this.slides()[0] && this.slides()[0].dataset.mediaId);
    }

    observeSlides() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.slides().forEach((slide) => this.observer.observe(slide));
    }

    markActive(mediaId) {
      this.activeId = mediaId == null ? null : String(mediaId);
      this.thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(thumb.dataset.thumb === String(mediaId))));
      this.revealThumb();
      if (this.counter) {
        const index = this.group.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (index > -1) this.counter.textContent = String(index + 1);
      }
    }

    // Horizontal position (in the viewport scroll) at which a slide is aligned on the left edge
    slideLeft(slide) {
      return slide.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + this.viewport.scrollLeft;
    }

    // Puts a slide in place IMMEDIATELY: no animation and no snapping while it moves, so no photo
    // is seen sliding by (some browsers animate the CSS snap or the "auto" scroll behavior).
    // Snapping is restored once the position is stable.
    jumpTo(slide) {
      const viewport = this.viewport;
      if (!slide || !viewport) return;
      viewport.style.scrollSnapType = 'none';
      viewport.scrollLeft = this.slideLeft(slide);
      cancelAnimationFrame(this.snapFrame);
      this.snapFrame = requestAnimationFrame(() => {
        this.snapFrame = requestAnimationFrame(() => {
          viewport.style.scrollSnapType = '';
        });
      });
    }

    // Keeps the current thumbnail inside the thumbnail strip (the strip scrolls, never the page)
    revealThumb() {
      const list = this.thumbList;
      if (!list || list.hidden) return;
      const thumb = Array.from(this.thumbs).find((item) => item.dataset.thumb === this.activeId);
      if (!thumb) return;
      const box = list.getBoundingClientRect();
      const rect = thumb.getBoundingClientRect();
      if (rect.left < box.left) list.scrollLeft += rect.left - box.left - 8;
      else if (rect.right > box.right) list.scrollLeft += rect.right - box.right + 8;
    }

    // Previous / next photo of the variant shown (never a photo of another variant); loops at the ends
    step(delta) {
      const visible = this.slides();
      if (visible.length < 2) return;
      let index = visible.findIndex((slide) => slide.dataset.mediaId === this.activeId);
      if (index < 0) index = 0;
      let target = index + delta;
      let wrapped = false;
      if (target < 0) {
        target = visible.length - 1;
        wrapped = true;
      } else if (target >= visible.length) {
        target = 0;
        wrapped = true;
      }
      // Smooth for a neighbouring photo, immediate when looping (no scrolling through every photo)
      this.showMedia(visible[target].dataset.mediaId, !wrapped);
      this.announce();
    }

    // Tells screen readers which photo is shown ("Photo 2 of 5")
    announce() {
      if (!this.status) return;
      const slides = this.slides();
      const index = slides.findIndex((slide) => slide.dataset.mediaId === this.activeId);
      if (index < 0) return;
      this.status.textContent = (this.dataset.positionLabel || '').replace('__CURRENT__', String(index + 1)).replace('__TOTAL__', String(slides.length));
    }

    showMedia(mediaId, smooth) {
      const slide = this.slides().find((item) => item.dataset.mediaId === String(mediaId));
      if (!slide || !this.viewport) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (smooth && !reduce) this.viewport.scrollTo({ left: this.slideLeft(slide), behavior: 'smooth' });
      else this.jumpTo(slide);
      this.markActive(mediaId);
    }

    // After a change of variant (gallery that follows the variant): always the first photo of the group
    resetPosition() {
      const first = this.slides()[0];
      if (first) this.showMedia(first.dataset.mediaId, false);
    }

    // A photo marked [Option: Value; Other: Value] is shown when the variant has ALL these options;
    // several values of one option ([Couleur: Noir, Bleu]) mean "any of them".
    slideMatches(slide, keys) {
      return (slide.dataset.galleryRules || '')
        .split(';')
        .filter(Boolean)
        .every((rule) => {
          const parts = rule.split('=');
          return (parts[1] || '').split(',').some((value) => keys.includes(`${parts[0]}=${value}`));
        });
    }

    // Same rules as the Liquid of the section (initial rendering):
    // common photo ([Commun]) = always; marked photo = only if it matches; no marker or invalid
    // marker = hidden, except as the native main image of the variant. No match at all = empty list: the section
    // then shows its neutral "unavailable" visual, never the photos of other variants.
    visibleSlides(variant) {
      const keys = variant.keys || [];
      const featured = String(variant.media || '');
      const list = this.allSlides.filter((slide) => {
        const state = slide.dataset.galleryState;
        if (state === 'common') return true;
        if (state === 'targeted') return this.slideMatches(slide, keys);
        // no marker or invalid marker: only as the native main photo of the variant
        return slide.dataset.mediaId === featured;
      });
      return list;
    }

    // Shows or hides an element for good: the "hidden" attribute AND an inline rule that no stylesheet can override
    setShown(element, shown) {
      if (!element) return;
      element.hidden = !shown;
      if (shown) element.style.removeProperty('display');
      else element.style.setProperty('display', 'none', 'important');
    }

    // Makes the photos of the variant THE gallery: slides, thumbnails, counter and arrows all follow this.group.
    // Returns true when the list of photos has changed ("force" re-applies it to the page anyway).
    applyGallery(variant, force) {
      return this.applyGroup(this.visibleSlides(variant), force);
    }

    // The photos listed by the server for the variant (attribute "|id|id|"), as slides; null when there is no list
    servedGroup(attribute) {
      if (attribute === undefined || attribute === null) return null;
      const ids = attribute.split('|').filter(Boolean);
      return this.allSlides.filter((slide) => ids.includes(slide.dataset.mediaId));
    }

    sameGroup(list) {
      return list.length === this.group.length && list.every((slide, index) => slide === this.group[index]);
    }

    applyGroup(visible, force) {
      const same = this.sameGroup(visible);
      if (same && !force) return false;
      this.group = visible;
      const ids = new Set(visible.map((slide) => slide.dataset.mediaId));
      const count = visible.length;

      this.allSlides.forEach((slide) => this.setShown(slide, ids.has(slide.dataset.mediaId)));
      visible.forEach((slide, index) => slide.setAttribute('aria-label', `${index + 1} / ${count}`));
      const label = this.dataset.thumbLabel || '';
      let position = 0;
      this.thumbs.forEach((thumb) => {
        const shown = ids.has(thumb.dataset.thumb);
        this.setShown(thumb.closest('li'), shown);
        if (shown) {
          position += 1;
          if (label) thumb.setAttribute('aria-label', label.replace('__INDEX__', String(position)));
        }
      });
      if (this.counterTotal) this.counterTotal.textContent = String(count);
      this.setShown(this.counterBox, count >= 2);
      this.setShown(this.thumbList, count >= 2);
      this.setShown(this.prevButton, count >= 2);
      this.setShown(this.nextButton, count >= 2);
      this.setShown(this.emptyBox, count === 0);
      this.observeSlides();
      this.markActive(count ? visible[0].dataset.mediaId : null);
      return !same;
    }

    // ---- Quantity stepper
    setupQuantity() {
      const input = this.querySelector('[data-qty-input]');
      const minus = this.querySelector('[data-qty-minus]');
      const plus = this.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;
      minus.hidden = false;
      plus.hidden = false;
      const step = (delta) => {
        const min = parseInt(input.min || '1', 10);
        const next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      minus.addEventListener('click', () => step(-1));
      plus.addEventListener('click', () => step(1));
    }

    // ---- Variants
    selectedOptions() {
      const values = [];
      this.querySelectorAll('[data-option-index]').forEach((control) => {
        const index = parseInt(control.dataset.optionIndex, 10);
        if (control.tagName === 'SELECT') values[index] = control.value;
        else if (control.checked) values[index] = control.value;
      });
      return values;
    }

    preloadOptionMedia(event) {
      const input = event.target.matches && event.target.matches('[data-option-index]')
        ? event.target
        : event.target.closest && event.target.closest('.mp__swatch')?.querySelector('[data-option-index]');
      if (!input) return;

      const selected = this.selectedOptions();
      selected[parseInt(input.dataset.optionIndex, 10)] = input.value;
      const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (variant) this.preloadVariantMedia(variant);
    }

    preloadVariantMedia(variant) {
      const target = this.galleryByVariant
        ? this.visibleSlides(variant)[0]
        : this.allSlides.find((slide) => slide.dataset.mediaId === String(variant.media));
      const image = target && target.querySelector('img');
      if (!image) return;

      image.loading = 'eager';
      image.fetchPriority = 'high';
      const mediaId = target.dataset.mediaId;
      if (this.preloadedMedia.has(mediaId)) return;
      this.preloadedMedia.add(mediaId);
      if (image.complete) return;
      image.decode?.().catch(() => {});
    }

    onOptionChange() {
      const selected = this.selectedOptions();
      this.querySelectorAll('[data-selected-value]').forEach((label, index) => {
        if (selected[index]) label.textContent = selected[index];
      });
      const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
      const button = this.querySelector('.mp__add');
      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = this.dataset.unavailable;
        }
        return;
      }
      this.preloadVariantMedia(variant);
      const idInput = this.querySelector('[data-variant-id]');
      if (idInput) idInput.value = String(variant.id);
      // The gallery is repositioned immediately (no scrolling through the photos)
      if (this.galleryByVariant) {
        // Same photos (e.g. only the size changed): the visitor keeps the photo being viewed
        if (this.applyGallery(variant)) this.resetPosition();
      } else if (variant.media) {
        this.showMedia(variant.media, false);
      }
      this.currentMedia = variant.media;
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
      this.refresh(variant.id);
    }

    refresh(variantId) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.sectionId}`;
      fetch(url, { signal: this.controller.signal })
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          // The server list of the photos for this variant wins over the one computed here
          if (this.galleryByVariant) {
            const freshViewport = doc.querySelector('[data-viewport]');
            const served = this.servedGroup(freshViewport ? freshViewport.dataset.groupIds : null);
            if (served && !this.sameGroup(served)) {
              this.applyGroup(served);
              this.resetPosition();
            }
          }
          const price = doc.querySelector('[data-price]');
          const buy = doc.querySelector('[data-buy]');
          const currentPrice = this.querySelector('[data-price]');
          const currentBuy = this.querySelector('[data-buy]');
          if (price && currentPrice) currentPrice.innerHTML = price.innerHTML;
          if (buy && currentBuy) currentBuy.innerHTML = buy.innerHTML;
          // Update the "sold out" marks of the other options
          doc.querySelectorAll('[data-option-index]').forEach((fresh) => {
            const index = fresh.dataset.optionIndex;
            if (fresh.tagName === 'SELECT') {
              const current = this.querySelector(`select[data-option-index="${index}"]`);
              if (current) current.innerHTML = fresh.innerHTML;
              if (current) current.value = this.selectedOptions()[index];
            } else {
              const current = Array.from(this.querySelectorAll(`input[data-option-index="${index}"]`)).find((input) => input.value === fresh.value);
              if (current) {
                const wrapper = current.closest('.mp__swatch');
                const freshWrapper = fresh.closest('.mp__swatch');
                if (wrapper && freshWrapper) {
                  wrapper.classList.toggle('is-unavailable', freshWrapper.classList.contains('is-unavailable'));
                  const label = wrapper.querySelector('.visually-hidden');
                  const freshLabel = freshWrapper.querySelector('.visually-hidden');
                  if (label && freshLabel) label.textContent = freshLabel.textContent;
                }
              }
            }
          });
          if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
        })
        .catch((error) => {
          if (error.name !== 'AbortError') console.error(error);
        });
    }
  }

  if (!customElements.get('nomavik-product')) {
    customElements.define('nomavik-product', NomavikProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class NomavikProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.loadRecommendations();
    }

    async loadRecommendations() {
      try {
        const complementaryLoaded = await this.loadIntent('complementary');
        if (!complementaryLoaded) await this.loadIntent('related');
      } catch (error) {
        this.hidden = true;
      }
    }

    async loadIntent(intent) {
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('product_id', this.dataset.productId);
      url.searchParams.set('limit', this.dataset.limit);
      url.searchParams.set('intent', intent);

      const response = await fetch(url.toString());
      if (!response.ok) return false;
      const markup = document.createElement('div');
      markup.innerHTML = await response.text();
      const source = markup.querySelector(`product-recommendations[data-section-id="${this.dataset.sectionId}"]`);
      if (!source || !source.querySelector('[data-recommendations-ready]')) return false;

      this.innerHTML = source.innerHTML;
      this.dataset.loaded = 'true';
      this.hidden = false;
      return true;
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', NomavikProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
